<template>

    <timeregistration
        :can-admin="canAdmin"
        :can-finance="canFinance"
        :project-uuid="project.uuid"
        :hours-uri="route('api.v1.projects.hours.index', {project_uuid:project.uuid})"
        :process-uri="route('api.v1.projects.hours.store', {project_uuid:project.uuid})"
    ></timeregistration>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import Timeregistration from "../../../components/Projects/Timeregistration";

export default {

    components: {
        Timeregistration,
    },

    computed: {
        ...mapGetters([
            'can',
            'getProject',
        ]),

        canAdmin() {
            return this.can('admin', 'timeregistration');
        },

        canFinance() {
            return this.getProject.access.finance === true;
        },

        project() {
            return this.getProject;
        },
    },

    data() {
        return {
            Lang:Lang,
        }
    },

    metaInfo: {
        title:'Project uren',
    },

    name:'ProjectsDetailsHours',

}

</script>
